// extracted by mini-css-extract-plugin
module.exports = {"btnWrapper":"_1em_ey765aZn2KF69Ep2q-","cancelBtn":"_130iqVcnkUlXVdQvY6aF39","icon":"_2mGuOFJT0hyDSSjuYRVcuS","saveBtn":"_2lJh3HWniYHu0_jdLQYl2W"};